import React from 'react';
import { emitLeadChanged } from '../../lib/events';
import { inr, fmtDate, STATUS_COLORS } from '../../lib/format';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import { CommActions } from '../CommActions';
import { InfoRow, ActivityList } from './SummaryShared';
import { Pencil } from 'lucide-react';

export const LeadSummary = ({ data, onEdit }) => {
  const l = data.lead;
  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-heading font-bold text-lg leading-tight" data-testid="summary-lead-name">{l.lead_name}</div>
          {l.company_name && <div className="text-xs text-muted-foreground">{l.company_name}</div>}
        </div>
        <Badge variant="outline" className={`shrink-0 ${STATUS_COLORS[l.status] || ''}`} data-testid="summary-lead-status">{l.status}</Badge>
      </div>
      <CommActions lead={l} onLogged={(ld) => emitLeadChanged(ld)} showPhone />
      <Separator />
      <div>
        <InfoRow label="Deal Value" value={inr(l.total_deal_value)} testId="summary-lead-deal" />
        <InfoRow label="Cash Collected" value={inr(l.cash_collected)} />
        <InfoRow label="Source" value={l.source} />
        <InfoRow label="Setter / Closer" value={`${l.setter_name || '\u2014'} / ${l.closer_name || '\u2014'}`} />
        <InfoRow label="Next Follow-up" value={fmtDate(l.next_followup_date)} />
        <InfoRow label="Created" value={fmtDate(l.date_created)} />
        {!!l.monthly_retainer && <InfoRow label="Monthly Retainer" value={`${inr(l.monthly_retainer)} \u00d7 ${l.contract_period_months || 0} mo`} />}
      </div>
      <Separator />
      <ActivityList items={data.recent_activity || []} />
      <Button className="w-full" onClick={onEdit} data-testid="summary-edit-lead-button">
        <Pencil size={14} className="mr-1.5" /> Edit Lead
      </Button>
    </div>
  );
};
